import { logger } from '@mail-core/logger';
import type { LottieComponentProps } from 'lottie-react';
import React, { useEffect, useState } from 'react';
import Lottie from 'reactApp/ui/Lottie/Lottie';

type LottieFetchProps = Omit<LottieComponentProps, 'animationData'> & {
    src: string;
};

const LottieFetch = ({ src, ...props }: LottieFetchProps) => {
    const [animationData, setAnimationData] = useState<unknown>(null);

    useEffect(() => {
        let cancelled = false;

        fetch(src)
            .then((response) => response.json())
            .then((data) => {
                if (!cancelled) {
                    setAnimationData(data);
                }
            })
            .catch((error) => {
                logger.error(error);
            });

        return () => {
            cancelled = true;
        };
    }, [src]);

    if (!animationData) {
        return null;
    }

    return <Lottie {...props} animationData={animationData} />;
};

export default LottieFetch;
